import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * @Description: Description
 * @Author: Xiaohua Zhu
 * @Date: 2022-03-16 13:46:35
 * @LastEditors: Kun Yang
 * @LastEditTime: 2022-06-10 09:30:42
 */
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDown from '@/assets/arrow_down_blue.png';
import style from './reduceGoodsBox.module.scss';
const ReduceGoodsBox = ({ changeGoodsTips }) => {
    const { t } = useTranslation();
    console.log(changeGoodsTips);
    const [fold, setFold] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: style['reduce-goods-box-title'] }, { children: t('confirmMask.changesSize') }), void 0),
            _jsxs("div", Object.assign({ className: style['reduce-goods-box'] }, { children: [changeGoodsTips === null || changeGoodsTips === void 0 ? void 0 : changeGoodsTips.map((item, index) => (_jsx("p", Object.assign({ style: { display: (index > 1) && !fold ? 'none' : '' } }, { children: item.text }), item.name))),
                    (changeGoodsTips === null || changeGoodsTips === void 0 ? void 0 : changeGoodsTips.length) > 2 && !fold && (_jsx("div", { className: style['reduce-goods-gradient-box'] }, void 0))] }), void 0),
            (changeGoodsTips === null || changeGoodsTips === void 0 ? void 0 : changeGoodsTips.length) > 2 && (_jsxs("div", Object.assign({ className: style['fold-span'] }, { children: [_jsx("span", Object.assign({ onClick: () => setFold((fold) => !fold), role: "none" }, { children: fold ? t('put_away') : t('expand_more') }), void 0),
                    _jsx("span", Object.assign({ className: style['fold-img-span'] }, { children: _jsx("img", { src: ArrowDown, alt: "" }, void 0) }), void 0)] }), void 0))] }, void 0));
};
export default memo(ReduceGoodsBox);
